import loadingReducer from './loadingReducer';
import errorReducer from './errorReducer';

const apiReducer = (state = {}, action) => {
  return {
    loading: loadingReducer(state.loading, action),
    error: errorReducer(state.error, action),
  };
};

export default apiReducer;
